import { Component } from '@angular/core';

@Component({
  selector: 'lfw-toolbar-divider',
  templateUrl: './app-toolbar-divider.component.html',
  styleUrl: './app-toolbar-divider.component.scss',
  standalone: true
})
export class AppToolbarDividerComponent {}
